
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { monthlyRevenueData } from '@/utils/licenseService/salesData';

const RevenueBreakdownCard = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Monthly Revenue Breakdown</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[400px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={monthlyRevenueData}
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis tickFormatter={(value) => `$${value}`} />
              <Tooltip 
                formatter={(value) => [`$${value}`, 'Revenue']}
                labelFormatter={(label) => `Month: ${label}`}
              />
              <Legend />
              <Bar dataKey="totalRevenue" name="Total Revenue" fill="#4f46e5" />
              <Bar dataKey="masterLicenseShare" name="Master License Share" fill="#22c55e" />
              <Bar dataKey="resellerShare" name="Reseller Share" fill="#eab308" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default RevenueBreakdownCard;
